
<template>
  <div class="Pagination">
    <div class="box">
      <ul>
        <li class="dur" :class="{ disable: index == 1 }" @click="goto(index)">
          <span class="left durleft"></span>
        </li>
        <li
          v-for="(item, i) in page"
          :key="i"
          :class="{ acitve: i == index }"
          @click="goto(i)"
        >
          {{ i + 1 }}
        </li>
        <li
          class="dur"
          :class="{ disable: index == page.length  }"
          @click="goto(page.length )"
        >
          <span class="right"></span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    index: {
      type: Number,
      default: 1,
    },
    size: {
      type: Number,
      default: 6,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      arr: 1,
      page: [],
    };
  },
  mounted() {
  },
  methods: {
    calc() {
      var { index, total, size } = this;
      var page = Math.ceil(total / size);
      var arr = new Array(page);
      this.page = arr;
    },

    goto(i) {
      console.log(i)
      this.$emit("indexChange", i);
    },
  },
  watch: {
    index() {
      this.calc();
    },
    total() {
      this.calc();
    },
  },
};
</script>
<style lang="less">
.Pagination {
  text-align: center;

  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    li {
      width: 34px;
      height: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      line-height: 24px;
      color: #242a32;
      cursor: pointer;
    }
    .acitve {
      border-radius: 50%;
      border: 1px solid #2284f6;
      box-sizing: border-box;
    }
  }

  .dur {
    position: relative;
    span {
      width: 8px;
      height: 8px;
      border: 2px solid #8b97a4;
      border-left: transparent;
      border-bottom: transparent;
      transform: rotate(45deg);
    }
    .durleft {
      transform: rotate(-135deg) !important;
    }
  }

  .disable {
    cursor: not-allowed;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Pagination.vue